import React, {Component} from 'react'
import {Redirect} from 'react-router-dom'
import {Toaster, Intent} from '@blueprintjs/core'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import ReactGA from 'react-ga'

import {app, facebookProvider } from '../base'

const loginStyles = {
    width: "90%",
    maxWidth: "315px",
    margin: "20px auto",
    border: "1px solid #ddd",
    borderRadius: "5px",
    padding: "10px"
  };

class Login extends Component {
    constructor(props) {
        super(props)
        this.authWithFacebook = this.authWithFacebook.bind(this)
        this.authWithEmailPassword = this.authWithEmailPassword.bind(this)
        this.state = {
            redirect: false
        }
    }
    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }



    authWithFacebook() {
        app.auth().signInWithPopup(facebookProvider)
        .then((user, error)  => {
            if (error) {
                this.toaster.show({intent: Intent.DANGER, message: "unable to sign in with Facebook"})
            } else {
                ReactGA.event({
                    category: 'User',
                    action: 'Created an Account'
                  });             
                  this.props.setCurrentUser(user)
                this.setState({redirect : true })
   
            }

        })
        console.log("authed with facebook")
    }

    authWithEmailPassword(event) {
        event.preventDefault()
        console.log("authed with email")

        const email = this.emailInput.value
        const password = this.passwordInput.value

        var strongRegex = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$")
        app.auth().fetchProvidersForEmail(email)
        .then((providers) => {
            if (providers.length === 0) {
               
                if(!strongRegex.test(password)) {
                    this.toaster.show({intent: Intent.DANGER, message: "Passwords must be at least 8 charachters long, contain one uppercase and lowercase letter, and have a numeric digit" }) 
                    return
                }
                ReactGA.event({
                    category: 'User',
                    action: 'Created an Account'
                  });
                app.auth().createUserWithEmailAndPassword(email,password)
                
    
            }
            else if (providers.indexOf("password") === -1) {
                this.loginForm.reset()
                this.toaster.show({intent: Intent.WARNING, message: "Try Alternative login" })
            }
            else {
                return app.auth().signInWithEmailAndPassword(email, password)
            }
        }).then((user) => {
            if (user && user.email) {
                this.loginForm.reset()
                this.props.setCurrentUser(user)
                this.setState({redirect:true})
            }
        })
        .catch((error) => {
            this.toaster.show({intent: Intent.DANGER, message: error.message })
        })
      
    }

    render () {
        const {from} = this.props.location.state || { from: {pathname: '/'}}
        if (this.state.redirect === true ) {
            return <Redirect to={from} />

        }
        return (
            <div style={loginStyles}>
            <Toaster ref={(element) => {this.toaster =  element}} />
            <button style= {{width: "100%"}} className="pt-button pt-intent-primary"
            onClick={() => {this.authWithFacebook()}}> Log In using<span style={{width: "0.10em"}} /><FontAwesomeIcon icon={["fab", "facebook"]} />
            </button>
            <hr style={{marginTop: "10px", marginBottom: "10px"}}/>
            
            <form onSubmit={(event) => { this.authWithEmailPassword(event) }} ref={(form) => { this.loginForm = form }}>
            
            <div style={{marginBottom: "10px"}} className="pt-callout pt-icon-info-sign">
            <h5>Note</h5>
            If you do not have an account already, this form will create your account.
            </div>
            <label className="pt-label">
            Email
            <input style={{width:"100%"}} name= "email" className="pt-input" 
            name="email" type="email" ref={(input) => { this.emailInput = input}} placeholder="Email"/>
            </label>
            <label className="pt-label">
            Password
            <input style={{width:"100%"}} name= "password" className="pt-input" 
            name="password" type="password" ref={(input) => { this.passwordInput = input }} placeholder="Password"/>
            </label>
            <input style={{width:"100%"}} className="pt-button pt-intent-primary" type="submit" value="Log In">
            </input>
            </form>

            </div>
            
        )
    }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/Login.jsx